import React, { useContext } from 'react';
import Skeleton from 'react-loading-skeleton';
import ProgressBar from 'components/shared/ProgressBar';
import { getFormattedDurationFromSeconds } from 'utils/time';
import { isUndefined } from 'lodash';
import strings from 'common/strings';
import { VehicleCardContext } from '../VehicleCard';

const VehicleCardProgressBar = () => {
  const { vehicle, inExtensionCardMode, position } =
    useContext(VehicleCardContext);
  const currentStep = vehicle?.stepItem;
  if (!vehicle) {
    return (
      <div className="pb-2">
        <Skeleton height={inExtensionCardMode ? 0 : 30} />
      </div>
    );
  }
  if (!vehicle.vehicleCard.inRecon) return <hr />;
  if (vehicle?.stepItem?.state === 'COMPLETE') {
    return null;
  }

  let formattedActualStepDuration: string | undefined;
  let formattedTargetStepDuration: string | undefined;
  if (currentStep) {
    formattedActualStepDuration = isUndefined(
      currentStep.reconTimeInStepSeconds
    )
      ? strings.EMPTY_VALUE
      : getFormattedDurationFromSeconds(currentStep.reconTimeInStepSeconds);
    formattedTargetStepDuration = isUndefined(
      currentStep.recommendedDurationSeconds
    )
      ? strings.EMPTY_VALUE
      : getFormattedDurationFromSeconds(currentStep.recommendedDurationSeconds);
  }

  return (
    <>
      <div className="flex-columns space-between mr-3 ">
        <span className="VehicleCard-step-duration-goal VehicleCard-step-font Step-progress-title">
          {strings.STEP_PROGRESS}
        </span>
        <span
          className="VehicleCard-step-duration-goal VehicleCard-step-font Step-duration-text"
          id={`step-duration-text-${position}`}
        >
          {formattedActualStepDuration}
          <span className="slash"> / </span>
          {formattedTargetStepDuration}
        </span>
      </div>
      {currentStep && <ProgressBar currentStep={currentStep} />}
    </>
  );
};

export default VehicleCardProgressBar;
